import { useState, useEffect } from 'react'
import { Box, Button, Typography } from '@material-ui/core'
import axiosConfig from 'utils/axiosConfig'
import dayjs from 'dayjs'

import WelcomeSlide from './WelcomeSlide'
import QuestionSlide from './QuestionSlide'
import CompleteSlide from './CompleteSlide'
import SlideLoader from './SlideLoader'


const Examination = ({startTimer, onTimeEnd, resetTime, currentTime, examination, page, updatePage, updateProgress}) => {
  const [started, setStarted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [showCompleteSlide, setShowCompleteSlide] = useState(false)

  const [batchToken, setBatchToken] = useState('')
  const [attemptUuid, setAttemptUuid] = useState('')
  const [questions, setQuestions] = useState([])
  const [answers, setAnswers] = useState([])

  const startExamination = () => {
    setLoading(true)
    axiosConfig.get(`timed-examinations/${examination.id}/start-examination`)
      .then((response) => {
        const responseData = response.data

        if (!responseData.success) {
          setErrorMessage(responseData.message)
          setLoading(false)
          return
        }

        if (responseData.status === 'completed') {
          console.log('Exam is complete')
          setLoading(false)
          return
        }

        setBatchToken(responseData.batchToken)
        updatePage(responseData.page)
        updateProgress(responseData.progress)
        setQuestions(responseData.questions)
        setAttemptUuid(responseData.attempt)
        setStarted(true)

        const now = dayjs()
        const target = dayjs(responseData.expires_at)
        const diff = target.diff(now, 'second')

        startTimer(diff)

        setLoading(false)
      })
  }

  const submitAnswers = () => {
    setLoading(true)

    axiosConfig.post(`timed-examinations/${examination.id}/submit-answers`, {
      answers: answers,
      attempt: attemptUuid,
      batchToken: batchToken
    })
      .then((response) => {
        const responseData = response.data

        if (responseData.status === "completed") {
          setShowCompleteSlide(true)
          setLoading(false)
          return
        }

        startExamination()
      })
  }

  useEffect(() => {
    if (examination.hasProgress === true) {
      setLoading(true)
      startExamination()
    }
  }, [examination])

  useEffect(() => {
    // submitAnswers()
  }, [onTimeEnd])

  return (
    <Box>
      {showCompleteSlide === true && <CompleteSlide />}

      {loading === true && <SlideLoader />}

      {loading === false && showCompleteSlide === false && <>

        {started === false && <WelcomeSlide slideLoaded={() => setLoading(false)} nextSlide={startExamination} />}

        {started === true && <>
          <QuestionSlide
              key={1}
              questions={questions}
              onAnswerSelect={(answers) => setAnswers(answers)}
            />

          <Box
            display="flex"
            style={{backgroundColor: '#ffffff1c', position: 'sticky', bottom: '0px', padding: '10px 0px', backdropFilter: 'blur(3px)'}}>
            <Box flexGrow={1}>
              <Button
                variant="contained"
                color="primary"
                onClick={submitAnswers}
              >
                {page?.isLastPage === true
                  ? <><i className="fa fa-check"></i> &nbsp; Submit Answers & Complete Exam</>
                  : <>Lock In Answers & Next Page &nbsp; <i className="fa fa-arrow-right"></i></>
                }
              </Button>
            </Box>
            <Box display="flex" justifyContent="center" alignItems="center">
              <Typography variant="h5">
                Time Remaining: {currentTime}
              </Typography>
            </Box>
          </Box>
        </>}
      </>}
    </Box>
  )
}

export default Examination